<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style>

</style>
